export const APP_STORE_LINKS = {
  APP_STORE: "https://testflight.apple.com/join/Z4TRHxuQ",
  PLAY_STORE:
    "https://play.google.com/store/apps/details?id=com.weqiq.mobile&hl=en-US&ah=J_zsvlJxPzFItJdu9fJpB5ewCwA",
} as const;

